// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_Y2wnn","logo":"index_logo_SU5-0","breadcrumbs":"index_breadcrumbs_OLM3Q"};